import { LitElement, html, css } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';

import { authenticatedAPICall } from '../../client/api-client';
import {
  PickupOrderStatusStartLoading,
  PickupOrderStatusStartLoadingInProgress,
  PickupOrderStatusBeingLoaded,
} from '../../util/util';
import '../../elements/pickup-order/pickup-order';
import { showNotification } from '../../LanghoutBetonApp';
import { PickupOrder, getOrderIDs } from '../../types/types';

type PickupOrderList = PickupOrder[];

@customElement('langhout-beton-order-start-loading')
export class LanghoutBetonOrderStartLoading extends LitElement {
  static styles = css`
    :host([disableButtons]) {
      pointer-events: none;
      opacity: 0.7;
    }
  `;

  private limit = 100;
  private offset = 0;

  @property({ type: Boolean, reflect: true })
  private disableButtons = false;

  @property({ type: Array })
  private pickupOrders: PickupOrderList = [];

  constructor() {
    super();
    this.listPickupOrders();
    document.addEventListener(
      'refresh-tasks',
      this.refreshTaskListener as EventListener,
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(
      'refresh-tasks',
      this.refreshTaskListener as EventListener,
    );
  }

  refreshTaskListener = () => {
    this.listPickupOrders();
  };

  render() {
    if (this.pickupOrders.length === 0) {
      return html``;
    }
    return html`
      <h2>Start laden</h2>
      ${repeat(
        this.pickupOrders,
        pickupOrder => pickupOrder.id,
        pickupOrder => {
          return html`
            <pickup-order
              .pickupOrder="${pickupOrder}"
              @button-clicked=${async () => {
                this.disableButtons = true;
                if (
                  pickupOrder.status === PickupOrderStatusStartLoadingInProgress
                ) {
                  showNotification(
                    `Order: ${getOrderIDs(pickupOrder)} wordt geladen`,
                  );
                  await this.taskDone(pickupOrder);
                } else {
                  await this.pickUpTask(pickupOrder);
                }
                this.disableButtons = false;
              }}
            ></pickup-order>
          `;
        },
      )}
    `;
  }

  taskDone = async (pickupOrder: PickupOrder) => {
    const path = `/pickuporders/${pickupOrder.id}/status`;
    const body = {
      status: PickupOrderStatusBeingLoaded,
    };
    await authenticatedAPICall(
      path,
      'PUT',
      new Headers(),
      JSON.stringify(body),
    );
    this.listPickupOrders();
  };

  pickUpTask = async (pickupOrder: PickupOrder) => {
    const path = `/pickuporders/${pickupOrder.id}/status`;
    const body = {
      status: PickupOrderStatusStartLoadingInProgress,
    };
    await authenticatedAPICall(
      path,
      'PUT',
      new Headers(),
      JSON.stringify(body),
    );
    this.listPickupOrders();
  };

  listPickupOrders = async () => {
    const path = `/pickuporders/tasks?limit=${this.limit}&offset=${this.offset}&states=${PickupOrderStatusStartLoading},${PickupOrderStatusStartLoadingInProgress}`;

    const result = await authenticatedAPICall(path, 'GET', new Headers());
    if (result.statusCode !== undefined && result.statusCode >= 200 && result.statusCode < 300 && Array.isArray(result.body)) {
      this.pickupOrders = result.body as PickupOrderList;
    }
  };
}

declare global {
  interface HTMLElementTagNameMap {
    'langhout-beton-order-start-loading': LanghoutBetonOrderStartLoading;
  }
}
